import { FlatTreeControl } from "@angular/cdk/tree";
import { Component, Input, OnInit } from "@angular/core";
import { MatTreeFlatDataSource, MatTreeFlattener } from "@angular/material/tree";

interface ExampleFlatNode {
	expandable: boolean;
	name: string;
	level: number;
}

interface FoodNode {
	name: string;
	entity?: string;
	children?: FoodNode[];
}

@Component({
	selector: "app-tree",
	templateUrl: "./tree.component.html"
})
export class TreeComponent implements OnInit {
	@Input() treeControl = new FlatTreeControl<ExampleFlatNode>(
		node => node.level,
		node => node.expandable
	);

	private transformer = (node: FoodNode, level: number) => {
		return {
			expandable: !!node.children && node.children.length > 0,
			name: node.name,
			level
		};
	};
	// tslint:disable-next-line: member-ordering
	treeFlattener = new MatTreeFlattener(
		this.transformer,
		node => node.level,
		node => node.expandable,
		node => node.children
	);
	// tslint:disable-next-line: member-ordering
	@Input() dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
	@Input() selectName: string;

	constructor() {}

	hasChild = (_: number, node: ExampleFlatNode) => node.expandable;

	ngOnInit() {}
}
